<!-- 开屏页 -->
<template>
  <div class="guides">
    <div class="backBtn" @click="toStart()">
      <img src="./image/timg.png" alt="" />
    </div>
    <div class="nameCard" @click="changeEn()">
      <img src="./image/ch.png" alt="" v-if="languageType == 1" />
      <img src="./image/en.png" alt="" v-if="languageType == 2" />
    </div>
    <div class="lineCard" @click="linRoute()" v-if="lineBtnShow">
      <img src="./image/Group.png" alt="" v-if="lineShow" />
      <img src="./image/Mmap_btn_line.png" alt="" v-else />
    </div>
    <!-- 地图 -->
    <div id="container"></div>
    <div class="floorList">
      <div class="next" @click="reduceId()">
        <img src="./image/pre.jpg" alt="" />
      </div>
      <div
        :class="['floorlis', narIndex == index ? 'floorlisActive' : 'floorlis']"
        class="floorlis"
        v-for="(item, index) in initData.leftStrips"
        :key="item.id"
        @click="toGuides(item, index)"
      >
        {{ item.floorNumber }}
      </div>
      <div class="pass" @click="addId()">
        <img src="./image/next.jpg" alt="" />
      </div>
    </div>
    <div class="footer" v-if="skipWindowShow">
      <div class="cover">
        <div class="imgIcon">
          <img :src="$global.ImgUrl + pointDetailData.cover" alt="" />
        </div>
        <audio
          :src="$global.ImgUrl + pointDetailData.audio"
          id="audioPlayer"
        ></audio>
        <div class="playBtn" @click="audioPlay">
          <img src="./image/play.svg" alt="" v-if="!playing" />
          <img src="./image/pause.svg" alt="" v-else />
        </div>
      </div>
      <div class="pointName" @click="todetail(pointDetailData)">
        {{ pointDetailData.name }}
      </div>
    </div>
    <!-- 弹窗 -->
    <div class="leftLocation" @click="location()">
      <img src="./image/icon_location.svg" alt="" />
    </div>
  </div>
</template>
  
  <script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  indexApi,
  allTypeApi,
  poiDetailApi,
  routeDetailApi,
} from "../../request/api/index";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      mapObj: null, //初始化地图
      activeMarker: null, //当前点击的点位
      initData: [],
      initMapData: [],
      pointData: [],
      markers: [],
      pointDetailData: [],
      skipWindowShow: false,
      playing: false,
      routeDetailData: [],
      polyline: null, //路线的全局变量
      scenicId: "",
      id: "",
      narIndex: "",
      languageType: 1,
      lineShow: false,
      lineBtnShow: "",
      skipWindowData: [],
      wanPianList: [
        { name: "观光平台1F", num: 58355, id: 1 },
        { name: "观光平台2F", num: 58356, id: 2 },
        { name: "观光平台3F", num: 58357, id: 3 },
        { name: "观光平台4F", num: 58358, id: 4 },
        { name: "观光平台5F", num: 58359, id: 5 },
        { name: "观光平台6F", num: 58360, id: 6 },
        { name: "观光塔1", num: 58361, id: 7 },
        { name: "观光塔3", num: 58362, id: 12 },
        { name: "观光塔7", num: 58367, id: 13 },
        { name: "观光塔11", num: 58368, id: 14 },
        { name: "观光塔15", num: 58363, id: 8 },
        { name: "观光塔16", num: 58364, id: 9 },
        { name: "观光塔17", num: 58365, id: 10 },
        { name: "观光塔19", num: 58366, id: 11 },
      ],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //初始化地图
    initMap() {
      let that = this;
      this.mapObj = new AMap.Map("container", {
        view: new AMap.View2D({
          // 创建地图二维视口
          //   center: new AMap.LngLat(120.2720729999999, 30.720922),
          center: new AMap.LngLat(
            this.initMapData.longitude,
            this.initMapData.latitude
          ),
          zoom: this.initMapData.showZoom, //设置地图初始的的缩放级别
          // zoom: 12, //设置地图初始的的缩放级别
          rotation: 0, //设置地图旋转角度
        }),
        // zooms: [1, 20], //地图可缩放的级别
        zooms: [this.initMapData.minZoom, this.initMapData.maxZoom], //地图可缩放的级别
        lang: "zh_cn", //设置地图语言类型，默认：中文简体
        // features: ["bg", "road", "building"], //去除高德的瓦片
        features: [],
      });
      // // 瓦片加载
      for (var i in this.wanPianList) {
        if (this.wanPianList[i].id == this.id) {
          that.leLayer = new AMap.TileLayer({
            // 图块取图地址,加了s=1就是下沙景区限制
            tileUrl: `https://htyz.worldmaipu.com/upload_resource/${this.wanPianList[i].num}/[z]/[x]_[y].png`,
            // tileUrl: "http://192.18.61.250:88/42850/[z]/[x]_[y].png",
            zIndex: 100,
          });
        }
      }
      this.leLayer.setMap(this.mapObj);
      // var mybounds = new AMap.Bounds(
      //   [this.initMapData.lLongitude, this.initMapData.lLatitude],
      //   [this.initMapData.rLongitude, this.initMapData.rLatitude]
      // );
      // this.mapObj.setLimitBounds(mybounds);
      // let bounds = this.mapObj.getBounds(); //进行回到初始位置的方法
      // this.mapObj.setLimitBounds(bounds);
    },
    location() {
      this.mapObj.setCenter([
        this.initMapData.longitude,
        this.initMapData.latitude,
      ]);
    },
    //创建marker点位
    createMarker() {
      let that = this;
      var markerArr = this.pointData;
      for (var i in markerArr) {
        var markIcon, markSelectIcon;
        markIcon = new AMap.Icon({
          // 图标尺寸
          size: new AMap.Size(32, 32),
          // 图标的取图地址
          image: require("./image/click.png"),
          // 图标所用图片大小
          imageSize: new AMap.Size(32, 32),
          // 图标取图偏移量
          // imageOffset: new AMap.Pixel(-9, -3),
        });
        markSelectIcon = new AMap.Icon({
          // 图标尺寸
          size: new AMap.Size(32, 32),
          // 图标的取图地址
          image: require("./image/clickactive.png"),
          // 图标所用图片大小
          imageSize: new AMap.Size(32, 32),
          // 图标取图偏移量
          // imageOffset: new AMap.Pixel(-9, -3),
        });
        let marker = new AMap.Marker({
          position: new AMap.LngLat(
            markerArr[i].longitude,
            markerArr[i].latitude
          ), //marker点的位置
          icon: markIcon,
          offset: new AMap.Pixel(-13, -30), //marker内容的偏移量
          extData: {
            pioData: markerArr[i],
            markIcon: markIcon,
            markSelectIcon: markSelectIcon,
          },
        });
        // marker点击监听事件
        AMap.event.addListener(marker, "click", function (e) {
          that.markerClick(this);
        });
        //添加marker到地图
        this.markers.push(marker);
      }
    },
    // 点位改成 点击之前的样式
    markerSetNomal(marker) {
      if (this.activeMarker) {
        marker.setIcon(marker.getExtData().markIcon);
      }
    },
    // 点位改成 点击之后的样式
    markerSetClicked(marker) {
      if (this.activeMarker) {
        marker.setIcon(marker.getExtData().markSelectIcon);
      }
    },
    //点击marker
    markerClick(e) {
      this.getPointDetailData(e.getExtData().pioData);
      this.skipWindowData = e.getExtData().pioData;
      this.mapObj.setCenter(e.getPosition());
      if (this.playing) {
        this.playing = false;
        this.changeMarkAudioPlay();
      }
      if (this.activeMarker) {
        if (
          e.getExtData().pioData.id == this.activeMarker.getExtData().pioData.id
          // 如果已经有点被点击且 已经被点击的点和这次点击的点相同
        ) {
          if (this.skipWindowShow) {
            this.skipWindowShow = false;
            this.markerSetNomal(this.activeMarker);
            if (this.playing) {
              this.playing = false;
              this.changeMarkAudioPlay();
            }
          } else {
            this.skipWindowShow = true;
            this.markerSetClicked(this.activeMarker);
          }
          return;
        } else {
          this.skipWindowShow = true;
          this.markerSetNomal(this.activeMarker);
          if (this.playing) {
            this.playing = false;
            this.changeMarkAudioPlay();
          }
        }
      }
      this.skipWindowShow = true;
      e.setIcon(e.getExtData().markSelectIcon);
      this.activeMarker = e;
    },
    //切换层级
    toGuides(item, index) {
      let that = this;
      for (let i = 0; i < this.markers.length; i++) {
        if (this.markers[i].getExtData().pioData.id == this.skipWindowData.id) {
          that.markerSetNomal(this.markers[i]);
        }
      }
      this.narIndex = index;
      this.skipWindowShow = false;
      this.lineShow = false;
      if (this.playing) {
        this.playing = false;
        this.changeMarkAudioPlay();
      }
      this.id = item.id;
      this.getInitData();
    },
    reduceId() {
      if (this.narIndex > 0) {
        this.narIndex = this.narIndex - 1;
        this.skipWindowShow = false;
        this.lineShow = false;
        if (this.playing) {
          this.playing = false;
          this.changeMarkAudioPlay();
        }
        this.id = this.initData.leftStrips[this.narIndex].id;
        this.getInitData();
      }
    },
    addId() {
      if (this.narIndex < this.initData.leftStrips.length - 1) {
        this.narIndex = this.narIndex + 1;
        this.skipWindowShow = false;
        this.lineShow = false;
        if (this.playing) {
          this.playing = false;
          this.changeMarkAudioPlay();
        }
        this.id = this.initData.leftStrips[this.narIndex].id;
        this.getInitData();
      }
    },
    toStart() {
      this.$router.push("/");
    },
    todetail(e) {
      this.$router.push("/point/" + e.id + "/" + e.languageType);
    },
    //切换语言
    changeEn() {
      this.skipWindowShow = false;
      this.lineShow = false;
      this.playing = false;
      if (this.languageType == 1) {
        this.languageType = 2;
      } else {
        this.languageType = 1;
      }
      this.getInitData();
      localStorage.setItem("languageType", this.languageType);
    },
    // 音频播放停止事件
    audioPlay() {
      let that = this;
      let audio = document.getElementById("audioPlayer");
      // 改变播放/暂停图片
      if (audio.paused) {
        // 开始播放当前点击的音频
        audio.play();
        that.playing = true;
      } else {
        audio.pause();
        that.playing = false;
      }
      // 监听播放完成事件
      audio.addEventListener(
        "ended",
        function () {
          that.audioEnded();
        },
        false
      );
    },
    //  播放完成时把进度调回开始的位置
    audioEnded() {
      this.playing = false;
    },
    // 切换marker音频停止事件
    changeMarkAudioPlay() {
      let audio = document.getElementById("audioPlayer");
      // 改变播放/暂停图片
      if (audio.paused) {
        return;
      } else {
        audio.pause();
        this.playing = false;
      }
    },
    //线路的线的数据处理
    lineArrData(data) {
      var arr = [];
      for (var i in data) {
        var arr1 = [data[i].longitude, data[i].latitude];
        arr.push(arr1);
      }
      this.polineShow(arr);
    },
    //线路显示
    polineShow(arr) {
      // console.log(arr);
      this.polyline = new AMap.Polyline({
        path: arr,
        isOutline: true,
        showDir: true,
        outlineColor: "#fff",
        borderWeight: 1,
        strokeColor: "#26ca11",
        strokeOpacity: 1,
        strokeWeight: 4,
        // 折线样式还支持 'dashed'
        strokeStyle: "solid",
        // strokeStyle是dashed时有效
        strokeDasharray: [10, 5],
        lineJoin: "round",
        lineCap: "round",
        zIndex: 700,
      });
      this.polyline.setMap(this.mapObj);
      // 缩放地图到合适的视野级别
      // this.mapObj.setFitView([this.polyline]);
    },
    linRoute() {
      if (this.lineShow) {
        this.lineShow = false;
        this.mapObj.remove(this.polyline);
        this.polyline = null;
      } else {
        this.lineShow = true;
        this.getRouteDetailData();
      }
    },
    //线路详情数据
    getRouteDetailData() {
      routeDetailApi(this.id).then((res) => {
        if (res.status == "200") {
          this.routeDetailData = res.data.data;
          this.lineArrData(this.routeDetailData);
        }
      });
    },
    getInitData() {
      indexApi(this.scenicId).then((res) => {
        if (res.status == "200") {
          this.initData = res.data.data;
          console.log(res.data.data);
          for (let i = 0; i < this.initData.leftStrips.length; i++) {
            if (this.initData.leftStrips[i].id == this.id) {
              this.lineBtnShow = this.initData.leftStrips[i].isLine;
              this.narIndex = i;
              this.initMapData = res.data.data.leftStrips[i];
            }
          }
          this.initMap();
          this.getPointData();
        }
      });
    },
    getPointData() {
      allTypeApi({ id: this.id, languageType: 1 }).then((res) => {
        if (res.status == "200") {
          this.pointData = res.data.data;
          this.mapObj.remove(this.markers);
          this.markers = [];
          this.createMarker();
          this.mapObj.add(this.markers);
        }
      });
    },
    getPointDetailData(e) {
      poiDetailApi({ id: e.id, languageType: this.languageType }).then(
        (res) => {
          if (res.status == "200") {
            this.pointDetailData = res.data.data;
          }
        }
      );
    },
  },
  mounted() {
    if (localStorage.getItem("languageType")) {
      this.languageType = localStorage.getItem("languageType");
    } else {
      this.languageType = 1;
    }
    this.scenicId = this.$route.params.scenicId;
    this.id = this.$route.params.floorId;
    this.getInitData();
  },
};
</script>
<style lang="less">
.guides {
  width: 100%;
  height: 100vh;
  position: relative;
  //地图
  #container {
    width: 100%;
    height: 100%;
    position: relative;
    // 去除地图logo
    .amap-logo {
      display: none !important;
    }
    .amap-copyright {
      display: none !important;
      opacity: 0;
    }
    .contain {
      width: 3.2rem;
      height: 3.7rem;
      // background: url("./image/spot_route.svg") no-repeat;
      background-size: 100%;
      text-align: center;
      line-height: 3.3rem;
      font-size: 1.7rem;
    }
    .contain-active {
      width: 3.2rem;
      height: 3.7rem;
      // background: url("./image/spot_route (1).svg") no-repeat;
      background-size: 100%;
      text-align: center;
      line-height: 3.3rem;
      font-size: 1.7rem;
      color: #fff;
    }
    //marker的文本内容
    .amap-marker-label {
      position: absolute;
      z-index: 2;
      border: 1px solid white;
      border-radius: 2.1rem;
      background-color: white;
      color: #55775f;
      font-weight: 400;
      opacity: 0.96;
      white-space: nowrap;
      cursor: default;
      padding: 3px 1rem;
      font-size: 1.2rem;
      box-shadow: 0rem 0.4rem 0.4rem 0rem rgba(0, 0, 0, 0.1);
    }
    .nav-info {
      justify-content: space-between;
      background: #fff;
      // width: 150px;
      box-shadow: 0rem 4px 4px 0rem rgba(85, 64, 22, 0.1);
      border-radius: 5px;
      padding: 8px 7px;
      // height: 56px;
      position: relative;

      .info-box {
        width: 70px;
        height: 28px;
        border-radius: 15px;
        line-height: 28px;
        font-size: 13px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: CENTER;
        color: #43525c;
        letter-spacing: 0rem;
        display: flex;
        justify-content: center;
        align-items: center;
        .icon-hear {
          width: 1.8rem;
          height: 1.8rem;
          display: inline-block;
          opacity: 1;
          // background: url("./image/icon_nav.svg") no-repeat;
          background-size: 100%;
          margin-right: 3px;
        }
      }
      &::after {
        content: "";
        width: 0;
        height: 0;
        border-width: 8px 8px 0;
        border-style: solid;
        border-color: #fff transparent transparent;
        position: absolute;
        // bottom: -0px;
        bottom: -8px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 104;
      }
    }
  }
  .backBtn {
    width: 5rem;
    height: 4.2rem;
    position: absolute;
    left: 1.2rem;
    top: 1.2rem;
    z-index: 10;
    img {
      width: 100%;
    }
  }
  .nameCard {
    width: 2rem;
    height: 4rem;
    position: absolute;
    right: 1.2rem;
    top: 2.3rem;
    z-index: 10;
    img {
      width: 100%;
    }
  }
  .lineCard {
    width: 4rem;
    height: 4rem;
    position: absolute;
    right: 0.2rem;
    top: 7.5rem;
    z-index: 10;
    img {
      width: 100%;
    }
  }
  .floorList {
    width: 2.7rem;
    position: absolute;
    right: 1rem;
    margin-top: -12rem;
    top: 50%;
    z-index: 10;
    border: 0.1rem solid #61cdd9;
    background: #fff;
    .next {
      width: 2.5rem;
      height: 2.5rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .pass {
      width: 2.5rem;
      height: 2.5rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .floorlis {
      width: 2.5rem;
      height: 2.5rem;
      color: #61cdd9;
      text-align: center;
      line-height: 2.5rem;
      font-size: 1.5rem;
    }
    .floorlisActive {
      width: 2.5rem;
      height: 2.5rem;
      color: #fff;
      background-color: #61cdd9;
      text-align: center;
      line-height: 2.5rem;
      font-size: 1.5rem;
    }
  }
  .footer {
    width: 80%;
    height: 5.5rem;
    background: #fff;
    border: 0.06rem solid rgb(236, 236, 236);
    box-shadow: 0.04rem 0.04rem 0.06rem 0 rgba(103, 103, 103, 0.9);
    border-radius: 0.08rem;
    position: absolute;
    bottom: 1rem;
    margin-left: 50%;
    left: -40%;
    z-index: 10;
    border-radius: 0.5rem;
    .cover {
      width: 7rem;
      height: 7rem;
      position: absolute;
      left: 1rem;
      bottom: 1rem;
      padding: 0.06rem;
      background-color: #f2f2f2;
      border-radius: 0.5rem;
      border: 0.06rem solid rgb(236, 236, 236);
      .imgIcon {
        width: 100%;
        height: 100%;
        border-radius: 0.5rem;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .playBtn {
        width: 3rem;
        height: 3rem;
        border-radius: 50%;
        position: absolute;
        top: -1.5rem;
        margin-top: 50%;
        left: -1.5rem;
        margin-left: 50%;
        img {
          width: 100%;
          height: 100%;
          overflow: hidden;
        }
      }
    }
    .pointName {
      width: 55%;
      height: 2rem;
      position: absolute;
      right: 1rem;
      top: 1.75rem;
      color: #364a63;
      font-weight: 500;
      font-size: 1.2rem;
      overflow: hidden;
      // text-align: center;
      line-height: 2rem;
    }
  }
  .leftLocation {
    width: 3.2rem;
    height: 3.2rem;
    padding: 0.6rem;
    opacity: 0.96;
    background: #ffffff;
    border-radius: 50%;
    position: absolute;
    bottom: 6rem;
    left: 1.6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 0;
    img {
      width: 2.2rem;
      height: 2.2rem;
    }
  }
}
</style>